<template>
    <!-- CONTENT -->
    <div class="page-layout__inner candidate-view">

            <div class="page-layout__group">

                <!-- PERSON'S MAIN INFO -->
                <section class="section  employee-card  employee-card-expanded" style="z-index:2">

                    <div class="employee-card__inner">
                        <!-- LEFT -->
                        <div v-if="candidate.id" class="employee-card__left">
                            <div class="employee-card__header">
                                <a class="employee-card__toggle-btn" href="javascript:void(0)">
                                    <h2 class="employee-card__title">{{ candidate.fullName }}</h2>
                                </a>
                            </div>
                            <div class="employee-card__body">
                                <div class="person">
                                    <div class="person__inner">
                                        <div class="person__img--3x4 mr-3" id="upload-photo">
                                            <img :src="candidate.photoUrl || $config.noProfilePhotoUrl" />

                                            <div class="change_avatar" v-if="hasPermission('api.candidate.profile.photoChange')">
                                                <p><a id="change_photo" @click="$refs.avatarSelect.click()">
                                                    {{ getTranslation('uploadNewAvatar') }}
                                                </a></p>

                                                <input @change="uploadAvatar" style="display: none" ref="avatarSelect" type="file" accept="image/*" />
                                            </div>
                                        </div>
                                        <div class="person__info">
                                            <p class="text text--lg">{{ candidate.bdate }} ({{ candidate.age }})</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /.employee-card__body -->
                        </div>
                        <!-- / LEFT -->

                        <!-- RIGHT -->
                        <div class="employee-card__right">
                            <div class="employee-card__header">
                                <div class="title-h5">
                                    {{ getTranslation('generalInfo') }}
                                </div>
                            </div>
                            <div class="employee-card__body row">
                                <div class="employee-card__table col-md-6">
                                    <table v-if="candidate.id" class="table-doc">
                                        <tbody>
                                            <tr>
                                                <th class="table-doc__cell  table-doc__cell--head">
                                                    {{ getTranslation('pin') }}:
                                                </th>
                                                <td class="table-doc__cell">
                                                    {{ candidate.pin }}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th class="table-doc__cell  table-doc__cell--head">
                                                    {{ getTranslation('gender') }}:
                                                </th>
                                                <td class="table-doc__cell">
                                                    {{ candidate.genderText }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="table-doc__cell  table-doc__cell--head">
                                                    {{ getTranslation('bdate') }}:
                                                </th>
                                                <td class="table-doc__cell">
                                                    {{ candidate.bdate }} ({{ candidate.age }})
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="employee-card__contacts col-md-6">
                                    <table v-if="candidate.id" class="table-doc">
                                        <tbody>
                                            <tr>
                                                <th class="table-doc__cell  table-doc__cell--head">
                                                    {{ getTranslation('email') }}:
                                                </th>
                                                <td class="table-doc__cell">
                                                    {{ candidate.email }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- / RIGHT -->
                    </div>
                    <!-- /.employee-card__inner -->

                </section>
                <!-- / PERSON'S MAIN INFO -->

                <section class="tab-3 mt-3">
                    <ul class="nav  tabs-3__nav  tabs-3__hor-nav">
                        <li v-if="hasPermission('api.candidate.profile.applications')" class="tabs-3__nav-item">
                            <a @click="tabSelect('applications')" class="tabs-3__nav-link" :class="{'active':tabs['applications']}" href="javascript:void(0)">
                                {{ getTranslation('applications') }}
                            </a>
                        </li>
                        <li v-if="hasPermission('api.candidate.profile.logins')" class="tabs-3__nav-item">
                            <a @click="tabSelect('logins')" class="tabs-3__nav-link" :class="{'active':tabs['logins']}" href="javascript:void(0)">
                                {{ getTranslation('loginHistory') }}
                            </a>
                        </li>
                    </ul>
                    <div class="tabs-3__content  tabs-3__content--p-0">
                        <div v-if="hasPermission('api.candidate.profile.applications')" class="tabs-3__pane" :class="{ 'active': tabs['applications'] }">
                            <CandidateApplications :active="tabs['applications']" :candidate-id="$route.params.id" />
                        </div>
                        <div v-if="hasPermission('api.candidate.profile.logins')" class="tabs-3__pane" :class="{ 'active': tabs['logins'] }">
                            <CandidateLogins :active="tabs['logins']" :candidate-id="$route.params.id" :paginated="true" />
                        </div>
                    </div>
                </section>

            </div>

    </div>
</template>

<script>
    import candidateProfileMixin from "./mixins/CandidateProfile";
    import CandidateMixin from "./mixins/Candidate";
    import CandidateApplications from "./components/CandidateApplications";
    import CandidateLogins from "./components/CandidateLogins";

    export default {
        name: "CandidateView",
        components: { CandidateLogins, CandidateApplications },
        mixins: [candidateProfileMixin, CandidateMixin],
        data() {
            return {
                tabs: {
                    applications: false,
                    logins: false,
                },
            }
        },
        updated() {
            this.setHeadings( {
                title: this.getTranslation( 'candidateInfo' ),
                breadcrumbs: [
                    {
                        label: this.getTranslation( 'candidates' ),
                        route: { name: 'api.candidate.getList' }
                    },
                    {
                        label: this.getTranslation( 'candidateInfo' )
                    }
                ],
                toBack: {
                    route: { name: 'api.candidate.getList' },
                    label: this.getTranslation( 'gotoBack' )
                }
            } );
        },
        created() {
            this.fetchCandidate( this.$route.params.id );
            this.tabSelect(this.$route.query.tab || 'applications','applications',false)
        },
        methods: {
        }
    }
</script>

<style scoped>
.employee-card-expanded {
  max-width: 70% !important;
}
.employee-card__left {
  width: 50% !important;
}
.employee-card__right {
  width: 50% !important;
}
</style>
